<template>
    <div id="agaccount" class='gcardfr' v-loading='loading'>

        <el-row :gutter="20" class=''>
            <el-col :span='8'>
                <div class="glineflex">
                    <label class="glinelb">商户ID：</label>
                    <el-input size='small' v-model='merchantId' @keyup.enter.native="indexget"
                        :placeholder="$t('app_name')"></el-input>
                </div>


            </el-col>
            <el-col :span='8'>
                <div class="glineflex">
                    <label class="glinelb">审核时间：</label>
                    <el-date-picker v-model="dateRange" style="width: 340px" value-format="yyyy-MM-dd"
                        format="dd-MM-yyyy" type="daterange" range-separator="-" @change="rec_date"
                        start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
                </div>
            </el-col>

        </el-row>
        <el-table class='gtbtop' tooltip-effect="dark" :data="tableData" style="width: 100%">
            <el-table-column prop="adName" label="广告名称">
            </el-table-column>
            <el-table-column prop="merchantId" label="商户ID" width="200">
            </el-table-column>
            <el-table-column prop="adText" label="广告文本" width="200">
            </el-table-column>
            <el-table-column prop="adDescription" label="广告描述" width="200">
            </el-table-column>
            <el-table-column label="状态" width="200">
                <template slot-scope="scope">
                    <span v-if="scope.row.status == '0'">待审核</span>
                    <span v-if="scope.row.status == '1'">生成语料中</span>
                    <span v-if="scope.row.status == '2'">语料生成完成</span>
                    <span v-if="scope.row.status == '3'">生成语料失败</span>
                    <span v-if="scope.row.status == '6'">审核失败</span>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="200">
            </el-table-column>
            <el-table-column :label="$t('app_operation')" width="140">
                <template slot-scope="scope">
                    <el-button type='text' @click='editRow(scope.row)'>详情</el-button>
                    <el-button v-if="scope.row.status == '3'" type='text' @click='again(scope.row)'>重新生成</el-button>
                    <el-button v-if="scope.row.useStatus == '1' && scope.row.status == '2'" type='text'
                        @click='change_face(scope.row, 0)'>启用</el-button>
                    <el-button v-if="scope.row.useStatus == '0' && scope.row.status == '2'" type='text'
                        @click='change_face(scope.row, 1)'>禁用</el-button>
                </template>
            </el-table-column>
        </el-table>

        <Pages class='gpages' :cpage='page' :ctotal="total" :config='pconfig'></Pages>

        <el-dialog @close="closeDia" class='gstdia' title="详情" :visible.sync="showDia">
            <el-row>
                <el-col :span="12">
                    <label>广告名称：</label>
                    <label>{{ uform.adName }}</label>
                </el-col>
                <el-col :span="12">
                    <label>商户ID：</label>
                    <label>{{ uform.merchantId }}</label>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px;">
                <el-col :span="12">
                    <label>广告文本</label>
                    <label>{{ uform.adText }}</label>
                </el-col>
                <el-col :span="12">
                    <label>广告描述：</label>
                    <label>{{ uform.adDescription }}</label>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px;">
                <el-col :span="12">
                    <label>状态：</label>
                    <label v-if="uform.status == '0'">待审核</label>
                    <label v-if="uform.status == '1'">生成语料中</label>
                    <label v-if="uform.status == '2'">语料生成完成</label>
                    <label v-if="uform.status == '3'">生成语料失败</label>
                    <label v-if="uform.status == '6'">审核失败</label>
                </el-col>
                <el-col :span="12">
                    <label>创建时间：</label>
                    <label>{{ uform.createTime }}</label>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px;">
                <el-col :span="12">
                    <label>广告策略：</label>
                    <label v-if="uform.strategyData.type == '0'">推送播报</label>
                    <label v-if="uform.strategyData.type == '1'">循环次数</label>
                    <label v-if="uform.strategyData.type == '2'">循环间隔</label>
                </el-col>
                <el-col :span="12">
                    <label v-if="uform.strategyData.type == '0'">播报{{ uform.strategyData.value }}次 , 广告{{
                        uform.strategyData.count
                        }}次</label>
                    <label v-if="uform.strategyData.type == '1'">循环间隔 , {{ uform.strategyData.value }}秒播报</label>
                    <label v-if="uform.strategyData.type == '2'">循环次数 , {{ uform.strategyData.value }}次播报</label>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px;" v-if="uform.refuseReason">
                <el-col :span="12">
                    <label>拒绝原因：</label>
                    <label>{{ uform.refuseReason }}</label>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<style>
.edttcolor {
    margin-top: 20px;
}

.eqbs-ball-green {
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 6px;
    overflow: hidden;
    background: rgba(82, 196, 26, 1);
}

.eqbs-ball-gray {
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 6px;
    overflow: hidden;
    background: rgba(191, 191, 191, 1);
}
</style>

<script>
import Pages from '@/components/Pages.vue'
export default {
    data() {
        return {
            dateRange: [],
            merchantId: '',
            forms: {},
            isEdit: false,
            srcKey: '',
            pconfig: '',
            tableData: [],
            showDia: false,
            uform: {
                strategyData: {}
            },
            page: 1,
            total: 0,
            loading: false,
            sRows: [],
            innerVisible: false,
            beginTime: '',
            endTime: '',
        }
    },
    components: {
        Pages,
    },
    methods: {
        change_face(item, idx) {
            this.loading = true
            this.$AdvUpdate(item.id, idx, res => {
                this.loading = false
                if (res.status == 200) {
                    this.getList()
                } else {
                    this.$message.error(res.message)
                }
            }, () => {
                this.loading = false
            })
        },
        again(item) {
            this.loading = true
            this.$AdvRebuild(item.id, res => {
                this.loading = false
                if (res.status == 200) {
                    this.getList()
                } else {
                    this.$message.error(res.message)
                }
            }, () => {
                this.loading = false
            })
        },
        rec_date() {
            if (this.dateRange !== null) {
                this.beginTime = this.dateRange[0]
                this.endTime = this.dateRange[1]
                this.getList()
            } else {
                this.beginTime = ""
                this.endTime = ""
                this.getList()
            }
        },
        indexget() {
            this.page = 1
            this.getList()
        },
        editRow(row) {
            this.$reviewListDetail(row.id, res => {
                this.loading = false
                if (res.status == 200) {
                    this.uform = res.data
                    this.showDia = true
                } else {
                    this.$message.error(res.message)
                }
            }, () => {
                this.loading = false
            })
        },
        delRqs(id) {
            this.loading = true
            this.$delConf(id, res => {
                this.loading = false
                if (res.status == 200) {
                    this.getList()
                } else {
                    this.$message.error(res.message)
                }
            }, () => {
                this.loading = false
            })
        },
        getList() {
            this.loading = true
            this.$AdvPageList(this.page, this.$gRow, this.beginTime, this.endTime, this.merchantId, res => {
                this.loading = false
                if (res.status == 200) {
                    this.total = res.total
                    this.tableData = res.data
                } else {
                    this.$message.error(res.message)
                }
            }, '')
        },
        batchSelected(val) {
            this.sRows = val
        },
        closeDia() {
            this.showDia = false
            this.uform = { strategyData: {} }
        },
    },
    mounted() {
        var _this = this
        this.pconfig = {
            callback: page => {
                ///
                _this.page = page
                _this.getList()
            }
        }

        // this.setMc('')

        this.getList()
    }
}
</script>
